import { render, staticRenderFns } from "./RecoverAccount.vue?vue&type=template&id=3f67fe7e&scoped=true&"
import script from "./RecoverAccount.vue?vue&type=script&lang=js&"
export * from "./RecoverAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f67fe7e",
  null
  
)

export default component.exports